<template>
	<div class="position-relative w-100">
		<!-- Scrollable content -->
		<div
			ref="scrollContainer"
			class="d-flex overflow-auto hide-scrollbar"
			style="scroll-behavior: smooth; -webkit-overflow-scrolling: touch;"
		>
			<slot />
		</div>

		<!-- Left arrow -->
		<b-button
			v-if="showLeft"
			pill
			variant="secondary"
			size="sm"
			class="scroll-btn scroll-btn-left shadow"
			@click="scrollLeft"
		>‹</b-button>

		<!-- Right arrow -->
		<b-button
			v-if="showRight"
			pill
			variant="secondary"
			size="sm"
			class="scroll-btn scroll-btn-right shadow"
			@click="scrollRight"
		>›</b-button>
	</div>
</template>

<script>
export default {
	name: "HorizontalScroller",
	data() {
		return {
			showLeft: false,
			showRight: false,
			resizeObserver: null,
		};
	},
	mounted() {
		const el = this.$refs.scrollContainer;

		// Update on load, scroll, and resize
		this.updateArrows();
		el.addEventListener("scroll", this.updateArrows);
		window.addEventListener("resize", this.updateArrows);

		// Observe changes to content size
		if ("ResizeObserver" in window) {
			this.resizeObserver = new ResizeObserver(this.updateArrows);
			this.resizeObserver.observe(el);
		}
		// Watch for DOM changes in children (items added/removed)
		if ("MutationObserver" in window) {
			this.mutationObserver = new MutationObserver(() => this.updateArrows());
			this.mutationObserver.observe(el, { childList: true, subtree: true });
		}
	},
	beforeDestroy() {
		const el = this.$refs.scrollContainer;
		el.removeEventListener("scroll", this.updateArrows);
		window.removeEventListener("resize", this.updateArrows);

		this.resizeObserver?.disconnect?.();
		this.mutationObserver?.disconnect?.();
	},
	methods: {
		updateArrows() {
			const el = this.$refs.scrollContainer;
			if (!el) return;
			this.showLeft = el.scrollLeft > 0;
			this.showRight = el.scrollLeft + el.clientWidth < el.scrollWidth;
		},
		scrollLeft() {
			const el = this.$refs.scrollContainer;
			el.scrollBy({ left: -el.clientWidth * 0.9, behavior: "smooth" });
		},
		scrollRight() {
			const el = this.$refs.scrollContainer;
			el.scrollBy({ left: el.clientWidth * 0.9, behavior: "smooth" });
		},
	},
};
</script>

<style>
.scroll-btn {
	position: absolute;
	z-index: 1;
	opacity: 0.85;
	transform: translateY(-50%) !important;
	top: 50%;
	padding-left: .8em;
	padding-right: .8em;
}
.scroll-btn-left {
	left: .2em;
}
.scroll-btn-right {
	right: .2em;
}

/* Hide scrollbar but keep functionality */
.hide-scrollbar::-webkit-scrollbar {
	display: none;
}
.hide-scrollbar {
	-ms-overflow-style: none;  /* IE and Edge */
	scrollbar-width: none;  /* Firefox */
}
</style>
